import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { VirtualScrollerModule } from 'ngx-virtual-scroller';

import { I18nModule } from '@recruitee/i18n';
import {
  ButtonModule,
  DropdownModule,
  FormFieldModule,
  HeadingModule,
  IconModule,
  InputModule,
  SelectModule,
} from '@recruitee/user-interface';

import { EmojiFallbackHtmlPipe } from './emoji-fallback-html/emoji-fallback-html.pipe';
import { EmojiListComponent } from './emoji-list/emoji-list.component';
import { EmojiComponent } from './emoji/emoji.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    VirtualScrollerModule,
    I18nModule,

    HeadingModule,
    FormFieldModule,
    InputModule,
    SelectModule,
    DropdownModule,
    IconModule,
    ButtonModule,
  ],
  declarations: [EmojiListComponent, EmojiComponent, EmojiFallbackHtmlPipe],
  exports: [EmojiListComponent, EmojiFallbackHtmlPipe, EmojiComponent],
})
export class EmojiModule {}
